import axios from "axios";

export function deleteSongAPI(action) {
  const metaData = {
    withCredentials: true
  };

  return new Promise((resolve) => {
    axios
      .delete(
        `${process.env.REACT_APP_BACKEND}/delete_song/${action.uniqueName}`,
        metaData
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((e) => {
        resolve(e);
      });
  });
}
